export const range = (size: number, startAt = 0): Array<any> => {
	return [...(Array(size).keys() as any)].map((i) => i + startAt);
};

export const rangeStEnd = (startAt = 0, endAt = 0, inc = 1): Array<any> => {
	return [...(Array(endAt - startAt).keys() as any)].map((i) => startAt + i + inc);
};
